import { atom } from 'jotai'

export const isLoggedInAtom = atom<boolean>(localStorage.getItem('isLoggedIn') === 'true')
